import React, {FC} from "react";
import {useResponsiveContext} from "../../../MainApp/HomeApp/ResponsiveContext";

interface Props {
    address: string;
    phones: string[];
    email: string;
}

export const ContactDetails: FC<Props> = ({address, phones, email}) => {

    const {pageWidth} = useResponsiveContext();
    const style = pageWidth < 480 ? {display: "block", top: '5%'} : {}

    return (
        <div className="sc_googlemap_content sc_googlemap_content_detailed" style={style}>
            <div className="wpb_text_column wpb_content_element ">
                <div className="wpb_wrapper">
                    <p><em><b>Adres:</b></em><br/>{address}</p>
                    <p><em><b>Telefony:</b></em><br/>
                        {
                            phones.map((phone, index) => {
                                return <React.Fragment key={index}>{phone}<br/></React.Fragment>
                            })
                        }
                    </p>
                    <p><em><b>E-mail:</b></em><br/>{email}</p>
                </div>
            </div>
        </div>
    )
};